import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const Toaster = () => {
  return <ToastContainer position="top-right" autoClose={3000} hideProgressBar />;
};

// Export toast for easy use
export const showToast = (message: string, type: "success" | "error" | "info" | "warning" = "info") => {
  toast[type](message);
};
